"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Message2 = require("../../ui-components/Message");

var _constants = require("@insided/shared/constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var StatusMessage = function StatusMessage(_ref) {
  var status = _ref.status,
      message = _ref.message;

  if (!status) {
    return null;
  }

  if (status === 'running' || status === 'started') {
    return (0, _preact.h)(_Message2.Message, {
      variant: "loading",
      fullWidth: true
    }, (0, _preact.h)("div", null, "Content synchronization is in progress."));
  }

  if (status === 'completed' && message) {
    return (0, _preact.h)(_Message2.Message, {
      variant: "success",
      fullWidth: true
    }, (0, _preact.h)("div", null, "Last imported at ", (0, _preact.h)(SyncDate, {
      date: message
    }), " (CET)."));
  }

  return (0, _preact.h)(_Message2.Message, {
    variant: "warning",
    fullWidth: true
  }, (0, _preact.h)("span", null, message));
};

var options = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  hourCycle: 'h23',
  minute: '2-digit'
};

var SyncDate = function SyncDate(_ref2) {
  var date = _ref2.date;
  var formattedDate = new Date(date).toLocaleDateString('en-US', options);
  return (0, _preact.h)("span", null, formattedDate);
};

var SyncContentStatus = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SyncContentStatus, _Component);

  var _super = _createSuper(SyncContentStatus);

  function SyncContentStatus(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SyncContentStatus);
    _this = _super.call(this, props);
    _this.state = {
      status: '',
      message: ''
    };
    _this.onSyncContent = _this.onSyncContent.bind((0, _assertThisInitialized2.default)(_this));
    _this.fetchStatus = _this.fetchStatus.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SyncContentStatus, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          isInstalled = _this$props.isInstalled,
          storedIsSettingEnabled = _this$props.storedIsSettingEnabled;

      if (isInstalled && storedIsSettingEnabled) {
        this.fetchStatus();
      }
    }
  }, {
    key: "onSyncContent",
    value: function () {
      var _onSyncContent = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  status: 'started'
                });
                _context.prev = 1;
                _context.next = 4;
                return _axios.default.get(this.props.syncUrl);

              case 4:
                window.setTimeout(this.fetchStatus, 30000);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);
                this.setState({
                  status: 'failed',
                  message: 'Sorry, something went wrong, please try again.'
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 7]]);
      }));

      function onSyncContent() {
        return _onSyncContent.apply(this, arguments);
      }

      return onSyncContent;
    }()
  }, {
    key: "fetchStatus",
    value: function () {
      var _fetchStatus = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var result, _result$data, _Message, _Status;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _axios.default.get(this.props.statusUrl);

              case 3:
                result = _context2.sent;
                _result$data = result.data, _Message = _result$data.Message, _Status = _result$data.Status;

                if (_Status === 'running' || _Status === 'started') {
                  this.setState({
                    status: _Status
                  });
                  window.setTimeout(this.fetchStatus, 30000);
                } else {
                  this.setState({
                    status: _Status,
                    message: _Message
                  });
                }

                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                this.setState({
                  status: 'failed',
                  message: 'Sorry, something went wrong, please try again.'
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function fetchStatus() {
        return _fetchStatus.apply(this, arguments);
      }

      return fetchStatus;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          status = _this$state.status,
          message = _this$state.message;
      var _this$props2 = this.props,
          isInstalled = _this$props2.isInstalled,
          storedIsSettingEnabled = _this$props2.storedIsSettingEnabled;
      var isLoading = status === 'running' || status === 'started';

      if (isInstalled && storedIsSettingEnabled) {
        return (0, _preact.h)("div", {
          className: "sync-container"
        }, (0, _preact.h)("div", null, "The search index is updated automatically every day. Run a synchronization if you\u2019d like to apply content updates to ", _constants.PLATFORM_BRAND_NAME, " immediately."), (0, _preact.h)(_Button.default, {
          size: "medium",
          className: "federated-search-sync-button",
          variant: "secondary",
          title: "Synchronize content",
          isLoading: isLoading,
          onClick: this.onSyncContent,
          disabled: isLoading
        }), (0, _preact.h)(StatusMessage, {
          status: status,
          message: message
        }));
      }

      return null;
    }
  }]);
  return SyncContentStatus;
}(_preact.Component);

exports.default = SyncContentStatus;